/**
 * 手机号正则
 */
export const mobileReg = /^1[3-9]\d{9}/;
/**
 * 整数正则
 */
export const integerReg = /^\d{6}/;
/**
 * url正则
 */
export const urlReg = /(https?):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
/**
 * 是否是微信浏览器
 */
export const isWechat = !!navigator.userAgent.toLocaleLowerCase().match(/micromessenger/i);
/**
 * 是否是IOS
 */
export const isIOS = !!navigator.userAgent.match(/ipad|iphone/i);
